import React from 'react';
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HistoryIcon from '@mui/icons-material/History';
import EstadoModo from '../../terminales/components/EstadoModo';

const headerCellSx = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.78rem',
  textTransform: 'uppercase',
  letterSpacing: 0.3,
  bgcolor: 'grey.50',
};

const TablaPosnetsChoferes = ({
  data,
  total,
  loading,
  error,
  terminalesPorId,
  terminalesCargadas,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  onCambiar,
  onHistorial,
}) => {
  if (error) {
    return <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>{error}</Alert>;
  }

  const renderModo = (posnet) => {
    if (!posnet) return null;
    const terminal = terminalesPorId[posnet];
    if (terminal) return <EstadoModo mode={terminal.operating_mode} />;
    if (!terminalesCargadas) return null;
    return (
      <Tooltip title="La terminal guardada no figura en Mercado Pago para esta empresa">
        <Chip label="No encontrada en MP" color="warning" size="small" variant="outlined" />
      </Tooltip>
    );
  };

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
      <TableContainer sx={{ position: 'relative', minHeight: 220 }}>
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255,255,255,0.7)',
              zIndex: 1,
            }}
          >
            <CircularProgress size={32} />
          </Box>
        )}
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellSx}>Chofer</TableCell>
              <TableCell sx={headerCellSx}>Sucursal</TableCell>
              <TableCell sx={headerCellSx}>Caja MP</TableCell>
              <TableCell sx={headerCellSx}>Posnet</TableCell>
              <TableCell sx={headerCellSx}>Modo</TableCell>
              <TableCell sx={{ ...headerCellSx, textAlign: 'center' }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 1,
                      py: 6,
                      color: 'text.secondary',
                    }}
                  >
                    <PersonIcon sx={{ fontSize: 40, opacity: 0.4 }} />
                    <Typography variant="body2">No hay choferes para mostrar</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              data.map((chofer) => (
                <TableRow key={chofer.id} hover>
                  <TableCell sx={{ fontSize: '0.82rem' }}>{chofer.nombre_apellido}</TableCell>
                  <TableCell sx={{ fontSize: '0.82rem' }}>{chofer.sucursal || '-'}</TableCell>
                  <TableCell sx={{ fontSize: '0.82rem' }}>{chofer.caja_mercadolibre || '-'}</TableCell>
                  <TableCell sx={{ wordBreak: 'break-all', fontSize: '0.82rem' }}>
                    {chofer.posnet || (
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.82rem' }}>
                        Sin asignar
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>{renderModo(chofer.posnet)}</TableCell>
                  <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<SwapHorizIcon fontSize="small" />}
                      onClick={() => onCambiar(chofer)}
                      sx={{ mr: 1 }}
                    >
                      {chofer.posnet ? 'Cambiar' : 'Asignar'}
                    </Button>
                    <Button
                      size="small"
                      color="inherit"
                      startIcon={<HistoryIcon fontSize="small" />}
                      onClick={() => onHistorial(chofer)}
                    >
                      Historial
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={total}
        page={page}
        rowsPerPage={pageSize}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={(e, newPage) => onPageChange(newPage)}
        onRowsPerPageChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
};

export default TablaPosnetsChoferes;
